import { useTranslation } from "react-i18next";

import { useActiveLanguages } from "../../../store/languages/language.selectors";

import { capitalize } from "../../../utils/helpers";

import { useLang, useMenu } from "../../../hooks";

import { IconSprite } from "../../ui/IconSprite/IconSprite";
import { TransitionBox } from "../../ui/TransitionBox/TransitionBox";
import { LanguagesList } from "./LanguagesList/LanguagesList";
import { addStyles } from "./addStyles";

import { Rotate } from "../../ui/Rotate/Rotate.styled";
import { BoxArrow, Lang, Wrapper } from "./Languages.styled";

export const Languages = () => {
  const { isOpen, wrapperRef, setIsOpen } = useMenu();
  const { langParam, changeLanguage } = useLang();
  const { languages } = useActiveLanguages();
  const {
    i18n: { language },
  } = useTranslation();
  const handleToggleLanguage = () => {
    setIsOpen(prev => !prev);
  };

  const handleKeyDown = event => {
    if (event.key === "Enter") {
      handleToggleLanguage();
    }
  };

  const location = "base";

  return (
    <Wrapper
      tabIndex={0}
      onClick={handleToggleLanguage}
      onKeyDown={handleKeyDown}
      role="button"
      aria-label="Toggle language menu"
      ref={wrapperRef}
    >
      <Lang>
        {capitalize(language)}

        <Rotate isOpen={isOpen}>
          <IconSprite tag="arrowDropdown" width="18" height="19" />
        </Rotate>
      </Lang>
      <TransitionBox isOpen={isOpen} addStyles={addStyles(location)}>
        <BoxArrow location={location}>
          <LanguagesList
            arrLang={languages}
            changeLanguage={changeLanguage}
            lang={langParam}
          />
        </BoxArrow>
      </TransitionBox>
    </Wrapper>
  );
};
